import React from "react";
import { ProgressBar } from "react-loader-spinner";
import styles from "./loaderWithOverlay.module.css";

function LoaderWithOverlay({ isLoading }) {
  if (!isLoading) return null;
  return (
    <div className={styles["loader-overlay"]}>
      <div className={`d-flex flex-column align-items-center `}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    </div>
  );
}

export default LoaderWithOverlay;
